import { removeAudioPlayerKeyFromSession, removeSession } from "~/lib/helperFuncation/sessionStorageService";
import { changeIsAudioPlayState, changeIsPlayingState } from "~/lib/store/slice/audioSlice";
import {
  onPauseVideo,
  onPlayVideo,
  setCurrentVideo,
  setCurrentVideoPosition,
  setVideoQueue,
  setYoutubeVideoIsPlay,
} from "~/lib/store/slice/youtubePlayerSlice";
import { useAppDispatch } from "~/lib/store/store";
import { VIDEO_PLAYER } from "~/utils/constant";

const useStopCurrentRunningVideoAudio = () => {
  const dispatch = useAppDispatch();
  const playCurrentVideo = (videoId: string | null) => {
    dispatch(onPlayVideo(videoId));
    // dispatch(setCurrentVideoId(videoId)); // Ensure video player pop up is playing
    // dispatch(changeIsAudioPlayState(false)); // Ensure audio player pop up is not playing
    dispatch(changeIsPlayingState(false)); // Ensure audio is not playing
    removeAudioPlayerKeyFromSession(); // Remove audio player key from session storage
  };

  const removeVideoPlay = () => {
    dispatch(onPauseVideo());
    dispatch(setYoutubeVideoIsPlay(false));
    dispatch(setCurrentVideo(null));
    dispatch(setCurrentVideoPosition(0));
    dispatch(setVideoQueue([]));
    removeSession(VIDEO_PLAYER.CURRENT_VIDEO);
    removeSession(VIDEO_PLAYER.VIDEO_QUEUE);
    removeSession(VIDEO_PLAYER.IS_VIDEO_PLAY);
    removeSession(VIDEO_PLAYER.CURRENT_VIDEO_POSITION);
    removeSession(VIDEO_PLAYER.VIDEO_QUEUE);
    removeSession(VIDEO_PLAYER.YOUTUBE_VIDEO_IS_PLAY);
  };
  return { playCurrentVideo, removeVideoPlay };
};

export default useStopCurrentRunningVideoAudio;
